"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var magnet_uri_1 = __importDefault(require("magnet-uri"));
var core_1 = require("stremio/core");
var useToast_1 = __importDefault(require("stremio/common/Toast/useToast"));
var useTorrent_1 = __importDefault(require("stremio/common/useTorrent"));
var useStreamingServer_1 = __importDefault(require("stremio/common/useStreamingServer"));
var HTTP_REGEX = /^https?:\/\/.+/i;
var usePlayUrl = function () {
    var core = (0, core_1.useCore)();
    var toast = (0, useToast_1.default)();
    var createTorrentFromMagnet = (0, useTorrent_1.default)().createTorrentFromMagnet;
    var streamingServer = (0, useStreamingServer_1.default)();
    var handlePlayUrl = (0, react_1.useCallback)(function (text) { return __awaiter(void 0, void 0, Promise, function () {
        var trimmed, encoded, e_1, parsed, serverReady;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!text || !text.trim())
                        return [2 /*return*/, false];
                    trimmed = text.trim();
                    if (!HTTP_REGEX.test(trimmed)) return [3 /*break*/, 5];
                    toast.show({
                        type: 'success',
                        title: 'Loading HTTP stream…',
                        timeout: 3000
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, core.transport.encodeStream({
                            name: '',
                            description: '',
                            url: trimmed,
                        })];
                case 2:
                    encoded = _a.sent();
                    if (typeof encoded === 'string') {
                        window.location.hash = "#/player/".concat(encodeURIComponent(encoded));
                        return [2 /*return*/, true];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error('Failed to encode stream:', e_1);
                    return [3 /*break*/, 4];
                case 4:
                    toast.show({
                        type: 'error',
                        title: 'Failed to load HTTP stream.',
                        timeout: 5000
                    });
                    return [2 /*return*/, false];
                case 5:
                    parsed = magnet_uri_1.default.decode(trimmed);
                    if (parsed && typeof parsed.infoHash === 'string') {
                        serverReady = streamingServer.settings !== null
                            && streamingServer.settings.type === 'Ready';
                        if (!serverReady) {
                            toast.show({
                                type: 'error',
                                title: 'Streaming server is not available. Cannot play magnet links.',
                                timeout: 5000
                            });
                            return [2 /*return*/, false];
                        }
                        createTorrentFromMagnet(trimmed);
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
            }
        });
    }); }, [streamingServer.settings, createTorrentFromMagnet]);
    return { handlePlayUrl: handlePlayUrl };
};
exports.default = usePlayUrl;
